var BlockView = require('views/block/base-block-view');
import IconLoadService from 'services/icon-load-service';
var ListView = BlockView.extend({
  className: 'lists',
  initialize: function() {
    if(this.model.get('icon_decorated')) {
      const iconsArray = this.model.get('items');
      iconsArray.forEach((item, index) => {
        const index_id = (index === 0) ? this.model.cid : `${this.model.cid}-${index}`;
        this.model.set('uuid',index_id);
        if(item.hasOwnProperty('icon_name')) {
          if (item.icon_prefix !== null) {
            IconLoadService.applyIcon(item.icon_name, index_id,item.icon_size, item.icon_prefix);
          } else {
            console.error(`A prefix is required for icon ${item.icon_name}`);
          }
        } else {
          if (item.hasOwnProperty('icon')) {
            IconLoadService.applyIcon(item.icon, index_id, item.icon_size);
          }
        }
      });
    }
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    this.renderMultipleNestedBlocks('items');
  },
  play: function() {
    this.readyToGo();
  }
});

module.exports = ListView;
